<template>
  <div class="service detail wrap">
    <div class="text-bg server">
      <div class="text-wrap">
        <p>{{ $t('consulting.detail.server.lineText.01') }}</p>
        <p>{{ $t('consulting.detail.server.lineText.02') }}</p>
        <p>{{ $t('consulting.detail.server.lineText.03') }}</p>
      </div>
    </div>
    <HalfPageLayout class="server title">
      <template #half-left>
        <div class="img server"></div>
      </template>
      <template #half-right>
        <div class="inner-contents">
          <div class="contents-title">
            <h3 style="line-height: 1.1">
              {{ $t('consulting.title.server') }}
            </h3>
            <h6>Server Management</h6>
            <h4>{{ $t('consulting.detail.server.subTitle') }}</h4>
          </div>
          <h5>{{ $t('consulting.detail.server.desc') }}</h5>
        </div>
      </template>
    </HalfPageLayout>
    <HalfPageLayout class="server summary bg-light">
      <template #half-left>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('consulting.detail.server.firstPage.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:hard-drives-thin"></Icon>
              <dl>
                <dt>{{ $t('consulting.detail.server.firstPage.contents.01.title') }}</dt>
                <dd>{{ $t('consulting.detail.server.firstPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1000">
              <Icon icon="ph:network-thin"></Icon>
              <dl>
                <dt>{{ $t('consulting.detail.server.firstPage.contents.02.title') }}</dt>
                <dd>{{ $t('consulting.detail.server.firstPage.contents.02.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1500">
              <Icon icon="ph:shield-check-thin"></Icon>
              <dl>
                <dt>{{ $t('consulting.detail.server.firstPage.contents.03.title') }}</dt>
                <dd>{{ $t('consulting.detail.server.firstPage.contents.03.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
      <template #half-right>
        <div class="img visual-01"></div>
      </template>
    </HalfPageLayout>
    <HalfPageLayout class="server summary">
      <template #half-left>
        <div class="img visual-02"></div>
      </template>
      <template #half-right>
        <div class="animation-bg">
          <div class="gear"><SvgGear /></div>
          <div class="gear"><SvgGear /></div>
        </div>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('consulting.detail.server.secondPage.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:activity-thin"></Icon>
              <dl>
                <dt>{{ $t('consulting.detail.server.secondPage.contents.01.title') }}</dt>
                <dd>{{ $t('consulting.detail.server.secondPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1000">
              <Icon icon="ph:warning-thin"></Icon>
              <dl>
                <dt>{{ $t('consulting.detail.server.secondPage.contents.02.title') }}</dt>
                <dd>{{ $t('consulting.detail.server.secondPage.contents.02.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1500">
              <Icon icon="ph:arrow-clockwise-thin"></Icon>
              <dl>
                <dt>{{ $t('consulting.detail.server.secondPage.contents.03.title') }}</dt>
                <dd>{{ $t('consulting.detail.server.secondPage.contents.03.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
    </HalfPageLayout>
    <section class="section server benefit">
      <h2 class="hl section-title">{{ $t('consulting.detail.server.benefit.title') }}</h2>
      <div class="section-contents">
        <div class="benefit-grid inner-contents">
          <div
            v-for="(item, key) in $tm('consulting.detail.server.benefit.contents')"
            :key="key"
            class="benefit-card"
            data-aos="fade-up"
          >
            <dt>{{ item.title }}</dt>
            <dd>{{ item.desc }}</dd>
          </div>
        </div>
        <router-link to="/contact" class="button big line">
          {{ $t('service.detail.contact') }}
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import HalfPageLayout from '@/components/HalfPageLayout'
import { Icon } from '@iconify/vue'
import SvgGear from '@/components/SvgGear'

export default {
  name: 'ConsultingDetailServer',
  components: { SvgGear, HalfPageLayout, Icon }
}
</script>

<style scoped>
</style>
